import { BusinessApiError } from '@infra/api/BusinessApiClient';
import { AuthError } from '@infra/auth/AuthService';
import { expiredLicenceCopy } from '@application/licence/LicenceExpiryCopy';

/** Message utilisateur pour les échecs auth / premier admin en mode distant. */
export function formatRemoteAuthError(err: unknown, fallback: string): string {
  if (err instanceof AuthError && err.code === 'LICENCE_EXPIRED') {
    return expiredLicenceCopy().body;
  }
  if (err instanceof BusinessApiError) {
    if (err.message.includes('URL API métier non configurée')) {
      return 'Serveur métier non configuré — contactez Nexxus.';
    }
    if (err.statusCode === 401) {
      if (
        err.code === 'installation_invalid' ||
        err.message.includes('Installation non autorisée')
      ) {
        return 'Ce poste n’est pas autorisé à joindre le serveur. Relancez l’application ou contactez Nexxus.';
      }
      if (err.code === 'installation_token_required') {
        return 'Session installation absente — relancez l’application.';
      }
      if (err.code === 'installation_expired') {
        return 'Session installation expirée — relancez l’application.';
      }
      return fallback;
    }
    if (err.statusCode === 503 || err.message.includes('indisponible')) {
      return 'Serveur métier injoignable — réessayez dans quelques instants.';
    }
    return err.message;
  }
  return fallback;
}
